module.exports = __webpack_public_path__ + "img/42_44.de92fd04.png";